import lottie from 'lottie-web';
import './array.from';
import './foreach';

export default (() => {

  let observer;
  let DOM = {};
  const animationSegments = {
    0: {  // Right and left - Path 1  HERO
      idle: true,
      segments: [0, 50],
      flying: false
    },
    1: {
      idle: false,
      segments: {
        launch: {
          segment: [51, 62]
        },
        postLaunch: false,
        fly: {
          segment: [63, 99],
          pathSelector: 'Page-1',
          offsetX: 597,  // 597 / 0
          offsetY: 525,  // 525 / 0
          offsetMobileX: 222, // 222 / 0
          offsetMobileY: 492, // 492 / 0
          mobileX: 2.7,
          mobileY: 1.07,
          mobileScale: 360,
          rotate: 'angle',
          speed: 0.007,
          scale: 560,  // width box bird
          direction: 'right'
        },
        preLand: false,
        land: {
          segment: [100, 122]
        }
      }
    },
    2: {  // slow strait - Path 2  RECRUITMENT
      idle: true,
      segments: [123, 171],
      flying: false
    },
    3: {
      idle: false,
      segments: {
        launch: {
          segment: [172, 188]
        },
        postLaunch: {
          segment: [189, 197]
        },
        fly: {
          segment: [198, 234],
          pathSelector: 'Page-2',
          offsetX: 641,  // 641 / 375
          offsetY: 502,  // 502 / 965
          offsetMobileX: 222, // 222 / -140
          offsetMobileY: 302, // 302 / 901
          mobileX: 3.3,
          mobileY: 1.22,
          mobileScale: 360,
          rotate: 'angle',
          speed: 0.009,
          scale: 560,  // width box bird
          direction: 'right'
        },
        preLand: {
          segment: [235, 242]
        },
        land: {
          segment: [243, 265]
        }
      }
    },
    4: {  // 360 first Path - 3  TECHNICAL
      idle: true,
      segments: [266, 361],
      flying: false
    },
    5: {
      idle: false,
      segments: {
        launch: {
          segment: [362, 378]
        },
        postLaunch: {
          segment: [379, 387]
        },
        fly: {
          segment: [388, 424],
          pathSelector: 'Page-3',
          offsetX: 614, // 614 / 315
          offsetY: 498, // 498 / fit under Strengths header 1590 - 1612
          offsetMobileX: 213, // 213 / 68
          offsetMobileY: -252, // -252 / 1413
          mobileX: 3.3,
          mobileY: 1.82,
          mobileScale: 360,
          rotate: 'flip-left',
          speed: 0.007,
          scale: 560,  // width box bird
          direction: 'left'
        },
        preLand: {
          segment: [425, 432]
        },
        land: {
          segment: [433, 455]
        }
      }
    },
    6: {  // Right and left - Path 4 - copied from 1 change idle STRENGTHS
      idle: true,
      segments: [266, 361],
      flying: false
    },
    7: {
      idle: false,
      segments: {
        launch: {
          segment: [362, 378]
        },
        postLaunch: false,
        fly: {
          segment: [388, 424],
          pathSelector: 'Page-4',
          offsetX: 610, // 610  / 312
          offsetY: 510, // 510  / 2502 - 2521
          offsetMobileX: 220, // 220 / -121
          offsetMobileY: 250, // 250 / 1900
          mobileX: 3,
          mobileY: 1.41,
          mobileScale: 360,
          rotate: 'angle',
          speed: 0.006,
          scale: 560,  // width box bird
          direction: 'right'
        },
        preLand: {
          segment: [425, 432]
        },
        land: {
          segment: [433, 455]
        }
      }
    },
    8: {  // 360 first Path - 5 copied from 3  EXPERIENCE
      idle: true,
      segments: [266, 361],
      flying: false
    },
    9: {
      idle: false,
      segments: {
        launch: {
          segment: [362, 378]
        },
        postLaunch: {
          segment: [379, 387]
        },
        fly: {
          segment: [388, 424],
          pathSelector: 'Page-5',
          offsetX: 598,  // 598 / 312
          offsetY: 525,  // 525 / 3256 - 3251
          offsetMobileX: 251, // 252 / -121
          offsetMobileY: -31, // -31 / 2421
          mobileX: 2.2,
          mobileY: 1.58,
          mobileScale: 360,
          rotate: 'flip-right',
          speed: 0.005,
          scale: 560,  // width box bird
          direction: 'right'
        },
        preLand: {
          segment: [425, 432]
        },
        land: {
          segment: [433, 455]
        }
      }
    },
    10: {  // last one Path -  6  BEHAVIOR
      idle: true,
      segments: [266, 361],
      flying: false
    },
    11: {
      idle: false,
      segments: {
        launch: {
          segment: [570, 586]
        },
        postLaunch: {
          segment: [587, 595]
        },
        fly: {
          segment: [596, 632],
          pathSelector: 'Page-6',
          offsetX: 576,  // 576
          offsetY: 525,  // 525  4021 - 4030
          offsetMobileX: 148,
          offsetMobileY: 68,
          mobileX: 2.5,
          mobileY: 1.536,
          mobileScale: 320,
          rotate: 'angle',
          speed: 0.007,
          scale: 450,  // width box bird
          direction: 'left'
        },
        preLand: {
          segment: [633, 640]
        },
        land: {
          segment: [641, 663]
        }
      }
    },
    12: {
      idle: true,
      segments: [664, 823],
      flying: false
    },
  };

  const ns = "http://www.w3.org/2000/svg";

  let currentSegment = 0;
  let anim;
  let purpleBird;
  let yellowBird;


  const cacheDOM = () => {
    DOM.bird = document.getElementById('bird');
    DOM.birdPurple = document.getElementById('purple-bird');
    DOM.birdYellow = document.getElementById('yellow-bird');
    DOM.paths = document.querySelectorAll('.main-path');
    DOM.disableButton = document.querySelector('.play-animation');
  };

  const initAnimations = () => {

    // main bird animation
    let animData = {
      container: DOM.bird,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      autoloadSegments: false,
      path: '/wp-content/themes/defra/dist/bird-animation/birds/main/data.json',
    };
    anim = lottie.loadAnimation(animData);

    //Purple bird animation
    let animPurple = {
      container: DOM.birdPurple,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      autoloadSegments: false,
      path: '/wp-content/themes/defra/dist/bird-animation/birds/purple/data.json',
    };
    purpleBird = lottie.loadAnimation(animPurple);

    // yellow bird animation
    let animYellow = {
      container: DOM.birdYellow,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      autoloadSegments: false,
      path: '/wp-content/themes/defra/dist/bird-animation/birds/yellow/data.json',
    };

    yellowBird = lottie.loadAnimation(animYellow);
  };

  const idleAnimation = (animationSegment) => {
    anim.playSegments(animationSegment.segments, true);
  };

  const triggerNextFlyingAnimation = () => {
    const thisAnimationSegment = animationSegments[currentSegment];

    if (thisAnimationSegment.idle) {
      idleAnimation(thisAnimationSegment);

      if (currentSegment < 12) {
        observer.observe(DOM.bird);
      }

    } else {
      flyAnimation(thisAnimationSegment);

    }

    currentSegment++;
  };

  // purple lad
  const flyPurple = (pathNumber) => {

  //  console.log('animating flying purple');

    purpleBird.play();

    let counter = 0;
    let direction = true;
    let point = {
      x: false,
      y: false
    };

    let pathContainer;
    let flySpeed;

    if (pathNumber === 1) {
      pathContainer = document.getElementById('path-p1');
      flySpeed = 0.02;

    } else if (pathNumber === 2) {
      pathContainer = document.getElementById('path-p2');
      flySpeed = 0.005;
    }

    const path = pathContainer.getElementsByTagNameNS(ns, "path");
    const flyLength = path[0].getTotalLength();


    const Animation = () => {

      let offsetX = 600;
      let offsetY = 2120;
      let scale = 1;

      if (parseInt(counter, 10) === 1) {
        direction = false;
      } else if (parseInt(counter, 10) < 0) {
        direction = true;
      }

      if (direction) {
        counter += flySpeed;
      }

      // Mobile adjustment

      let shrinkX = 1;
      let shrinkY = 1;

      const screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

      if (screenWidth < 798) {

        shrinkX = 3.3;
        shrinkY = 1.8;
        offsetX = 169;
        offsetY = 1300;
        scale = 0.75;
      }

      let cordX = path[0].getPointAtLength(counter * flyLength).x / shrinkX;
      let cordY = path[0].getPointAtLength(counter * flyLength).y / shrinkY;

      const x = cordX.toFixed(0) - offsetX;
      const y = cordY.toFixed(0) - offsetY;

      let pt1 = path[0].getPointAtLength((counter * flyLength) - 2);
      let pt2 = path[0].getPointAtLength((counter * flyLength) + 2);
      let angle = Math.atan2(pt1.y - pt2.y, pt1.x - pt2.x) * (180 / Math.PI) - 180;

      DOM.birdPurple.setAttribute("style", "transform: translate(" + x + "px," + y + "px) rotate(" + angle + "deg) scale(-" + scale + ",-" + scale + "); display: block;");

      if (x === point.x && y === point.y) {

        DOM.birdPurple.setAttribute("style", "transform: translate(" + x + "px," + y + "px) rotate(" + 0 + "deg) scale(" + scale + "," + scale + "); display: block;");

        return;
      }

      point = {
        x,
        y
      };
      requestAnimationFrame(Animation);
    };
    requestAnimationFrame(Animation);
  };

  // yellow lad
  const flyYellow = (pathNumber) => {

   // console.log('animating flying yellow');

    yellowBird.play();

    let counter = 0;
    let direction = true;
    let point = {
      x: false,
      y: false
    };

    let pathContainer;
    let flySpeed;

    if (pathNumber === 1) {
      pathContainer = document.getElementById('path-y1');
      flySpeed = 0.01;

    } else if (pathNumber === 2) {
      pathContainer = document.getElementById('path-y2');
      flySpeed = 0.008;
    }

    const path = pathContainer.getElementsByTagNameNS(ns, "path");
    const flyLength = path[0].getTotalLength();


    const Animation = () => {

      let offsetX = 600;
      let offsetY = 4550;
      let lunchPathTwo = -292;

      if (parseInt(counter, 10) === 1) {
        direction = false;
      } else if (parseInt(counter, 10) < 0) {
        direction = true;
      }

      if (direction) {
        counter += flySpeed;
      }

      // Mobile adjustment

      let shrinkX = 1;
      let shrinkY = 1;

      const screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

      if (screenWidth < 798) {

        shrinkX = 2;
        offsetX = 369;
        offsetY = 4710;
        lunchPathTwo = -215;
      }

      let cordX = path[0].getPointAtLength(counter * flyLength).x / shrinkX;
      let cordY = path[0].getPointAtLength(counter * flyLength).y / shrinkY;

      const x = cordX.toFixed(0) - offsetX;
      const y = cordY.toFixed(0) - offsetY;

      let pt1 = path[0].getPointAtLength((counter * flyLength) - 2);
      let pt2 = path[0].getPointAtLength((counter * flyLength) + 2);
      let angle = Math.atan2(pt1.y - pt2.y, pt1.x - pt2.x) * (180 / Math.PI) - 180;

      DOM.birdYellow.setAttribute("style", "transform: translate(" + x + "px," + y + "px) rotate(" + angle + "deg); display: block;");

      if (x === point.x && y === point.y) {

        DOM.birdYellow.setAttribute("style", "transform: translate(" + x + "px," + y + "px) rotate(" + 0 + "deg); display: none;");
        return;
      }


      if (x === lunchPathTwo) {
        flyYellow(2);
      }

      point = {
        x,
        y
      };
      requestAnimationFrame(Animation);
    };
    requestAnimationFrame(Animation);
  };

  // Big lad
  const flyAnimation = (animationSegment) => {

    const Launch = (LaunchSegment) => {
      //console.log('Playing launch segment');
      anim.playSegments(LaunchSegment.segment, true);

      return new Promise(resolve => {
        const loopCompleteEvent = () => {
          //console.log('Launch completed, moving on...');
          anim.removeEventListener('loopComplete', loopCompleteEvent);
          resolve();
        };

        anim.addEventListener('loopComplete', loopCompleteEvent);
      });
    };

    const PostLaunch = (PostLaunchSegment) => {
      if (PostLaunchSegment) {
        //console.log('Post Launch animation start');
        anim.playSegments(PostLaunchSegment.segment, true);
      }

      return new Promise(resolve => {
        if (!PostLaunchSegment) {
          //console.log('No PostLaunchSegment defined, moving on right away');
          resolve();
        } else {
          const loopCompleteEvent = () => {
            //console.log('Post Launch completed, moving on...');
            anim.removeEventListener('loopComplete', loopCompleteEvent);
            resolve();
          };

          anim.addEventListener('loopComplete', loopCompleteEvent);
        }
      });
    };

    const Fly = (FlySegment) => {
      anim.playSegments(FlySegment.segment, true);

      return new Promise(resolve => {
        let counter = 0;
        let direction = true;
        let point = {
          x: false,
          y: false
        };

        const pathContainer = document.getElementById(FlySegment.pathSelector);
        const path = pathContainer.getElementsByTagNameNS(ns, "path");
        const flyLength = path[0].getTotalLength();

        let offsetX = FlySegment.offsetX;
        let offsetY = FlySegment.offsetY;
        let scale = FlySegment.scale;
        let lunchPurple = 1614;
        let lunchYellow = 3900;
        let rotation = 3872;

        const Animation = () => {

          if (parseInt(counter, 10) === 1) {
            direction = false;
          } else if (parseInt(counter, 10) < 0) {
            direction = true;
          }

          if (direction) {
            counter += FlySegment.speed;
          }

          // Mobile adjustment

          let shrinkX = 1;
          let shrinkY = 1;

          const screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

          if (screenWidth < 798) {
            shrinkX = FlySegment.mobileX;
            shrinkY = FlySegment.mobileY;
            offsetX = FlySegment.offsetMobileX;
            offsetY = FlySegment.offsetMobileY;
            scale = FlySegment.mobileScale;
            lunchPurple = 1450;
            lunchYellow = 2897;
            rotation = 2850;
          }

          let cordX = path[0].getPointAtLength(counter * flyLength).x / shrinkX;
          let cordY = path[0].getPointAtLength(counter * flyLength).y / shrinkY;

          const x = cordX.toFixed(0) - offsetX;
          const y = cordY.toFixed(0) - offsetY;


          let pt1 = path[0].getPointAtLength((counter * flyLength) - 2);
          let pt2 = path[0].getPointAtLength((counter * flyLength) + 2);
          let angle = Math.atan2(pt1.y - pt2.y, pt1.x - pt2.x) * (180 / Math.PI) - 180;

          let right = "transform: translate(" + x + "px," + y + "px) rotate(" + angle + "deg) scale(1,1);";
          let left = "transform: translate(" + x + "px," + y + "px) rotate(" + angle + "deg) scale(1,-1);";
          let widthBird = "width: "+ scale +"px !important;";


          if (point.x === false && point.y === false) {
           // console.log('GETTING INITIAL DIRECTION FROM SEGMENT', FlySegment);
            switch (FlySegment.direction) {
              case 'left' :
              default :
                DOM.bird.setAttribute("style", left);
                break;

              case 'right' :
                DOM.bird.setAttribute("style", right);
                break;
            }
          } else {
            if (FlySegment.rotate === 'angle' && x >= point.x) {

              DOM.bird.setAttribute("style", right);
              DOM.bird.children[0].setAttribute("style", widthBird);
             // console.log('right angle ------> X  ', x, '|  Y ', y, '| ANGLE ', angle ,'| ', pt1.y - pt2.y, pt1.x - pt2.x);
            } else if (FlySegment.rotate === 'angle' && x < point.x) {

            //  console.log('left angle <------ X  ', x, '|  Y ', y, '| ANGLE ', angle);
              DOM.bird.setAttribute("style", left);
              DOM.bird.children[0].setAttribute("style", widthBird);
            } else if (FlySegment.rotate === 'flip-left') {

             // console.log('left flip <------ X  ', x, '|  Y ', y, '| ANGLE ', angle);

              DOM.bird.setAttribute("style", left);
              DOM.bird.children[0].setAttribute("style", widthBird);
            } else if (FlySegment.rotate === 'flip-right') {

             // console.log('right flip ------> X  ', x, '|  Y ', y, '| ANGLE ', angle);

              if (y < rotation) {
                DOM.bird.setAttribute("style", right);
                DOM.bird.children[0].setAttribute("style", widthBird);
              } else {
                DOM.bird.setAttribute("style", left);
                DOM.bird.children[0].setAttribute("style", widthBird);
              }
            }
          }

          if (x === point.x && y === point.y || pt1.y - pt2.y === 0 && pt1.x - pt2.x === 0 ) {

           // console.log('IDLE - ', angle);

            DOM.bird.setAttribute("style", "transform: translate(" + x + "px," + y + "px) rotate(" + 0 + "deg) scale(1,1);");

            resolve();
            return;
          }

          // start small lads

          if (y > 1400 && y < 1410) {
            flyPurple(1);
          } else if (y > lunchPurple && y < (lunchPurple + 5)) {
            flyPurple(2);
          }

          if (y >= lunchYellow && y < (lunchYellow + 2)) {
            flyYellow(1);
          }

          point = {
            x,
            y
          };
          requestAnimationFrame(Animation);
        };

        requestAnimationFrame(Animation);
      });
    };

    const PreLand = (PreLandSegment) => {
      if (PreLandSegment) {
        anim.playSegments(PreLandSegment.segment, true);
      }

      return new Promise(resolve => {
        if (!PreLandSegment) {
          resolve();
        } else {
          const loopCompleteEvent = () => {
            anim.removeEventListener('loopComplete', loopCompleteEvent);
            resolve();
          };

          anim.addEventListener('loopComplete', loopCompleteEvent);
        }
      });
    };

    const Land = (LandSegment) => {
      anim.playSegments(LandSegment.segment, true);

      return new Promise(resolve => {
        const loopCompleteEvent = () => {
          anim.removeEventListener('loopComplete', loopCompleteEvent);
          resolve();
        };

        anim.addEventListener('loopComplete', loopCompleteEvent);
      });
    };

    const triggerAnimationSequence = async (segments) => {
      await Launch(segments.launch);
      await PostLaunch(segments.postLaunch);
      await Fly(segments.fly);
      await PreLand(segments.preLand);
      await Land(segments.land);
      triggerNextFlyingAnimation();

    };

    triggerAnimationSequence(animationSegment.segments);
  };


  const disableAnimation = (e) => {
    e.preventDefault(e);

    const scrollMouse = document.querySelector('.mouse');

    let classes = DOM.disableButton.classList;
    const button = document.getElementById('disable');

    if (classes.contains('paused') || scrollMouse.classList.contains('paused')) {
      classes.remove('paused');
      scrollMouse.classList.remove('paused');
      button.innerHTML = 'Enable animation';

      anim.stop();
      DOM.bird.classList.add('paused');

      purpleBird.stop();  // ?
      yellowBird.stop();  // ?

      observer.unobserve(DOM.bird);

    } else {
      classes.add('paused');
      scrollMouse.classList.add('paused');

      button.innerHTML = 'Disable animation';

      anim.play();
      DOM.bird.classList.remove('paused');

      observer.observe(DOM.bird);
    }
  };

  const setupEventListener = () => {

    DOM.disableButton.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      disableAnimation(e);

    });
  };

  const initObserver = () => {
    const options = {
      rootMargin: '0px 0px -80%'
    };

    observer = new IntersectionObserver(observeElements, options);
    observer.observe(DOM.bird);
  };

  const observeElements = entries => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {
        //console.log('fly !!! unobserve');

        observer.unobserve(entry.target);

        triggerNextFlyingAnimation();
      }
      anim.addEventListener('DOMLoaded', () => {
        triggerNextFlyingAnimation();
      });

    });
  };

  const init = () => {
    cacheDOM();
    initAnimations();
    setupEventListener();
    initObserver();
  };

  return {
    init
  };

})();



// WEBPACK FOOTER //
// ./src/js/modules/bird-animation.js